import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { Feature } from '@/types/features';

export const GET_FEATURE_QUERY_KEY = 'get-feature';

export const useGetFeatureQuery = (id?: string) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_FEATURE_QUERY_KEY, id],
    queryFn: async () => {
      const token = await getToken();
      return getFeature(id!, token ?? '');
    },
    enabled: !!id,
  });
};

const getFeature = async (id: string, token: string): Promise<Feature> => {
  const url = `${import.meta.env.VITE_API_URL}/features/${id}`;
  return sendJSONRequest({ url, method: METHOD.GET, token }) as Promise<Feature>;
};
